import AccessCodeService from 'services/AccessCodeService';
import {
  DISPLAY_ACCESS_CODE_RESULT,
  PROCESS_ACCESS_CODE_REQUESTED,
  PROCESS_ACCESS_CODE_SUCCESS,
  PROCESS_ACCESS_CODE_FAILURE,
} from 'actiontypes/accessCodes';

import { processMessages } from 'actions/app';

const displayAccessCodeResult = data => ({ type: DISPLAY_ACCESS_CODE_RESULT, payload: data });
const processAccessCodeRequest = () => ({ type: PROCESS_ACCESS_CODE_REQUESTED });
const processAccessCodeSuccess = data => ({ type: PROCESS_ACCESS_CODE_SUCCESS, payload: data });
const processAccessCodeFailure = error => ({ type: PROCESS_ACCESS_CODE_FAILURE, payload: error });

const service = new AccessCodeService();

export default function processAccessCode(name) {
  return async (dispatch) => {
    dispatch(processAccessCodeRequest());
    try {
      const { data } = await service.processAccessCode(name);
      dispatch(processAccessCodeSuccess(data));
      dispatch(displayAccessCodeResult(data));

      const { isSuccess, messages } = data;
      if (isSuccess && messages) {
        dispatch(processMessages(messages));
      }
    } catch (e) {
      dispatch(processAccessCodeFailure(e));
    }
  };
}